document.addEventListener('octane.quiz.completed', function (e) {
  let queryString = ""
  let kitType = ""
  let answers = e.detail.answers
  let name = answers["name"]
  let goals = answers["curl-goals"]
  let hairType = answers["hair-type"].toLowerCase()
  let holdStrength = answers["hold-strength"]
  let refresh = answers["desire-refresh"].toLowerCase()

  console.log('goals')
  console.log(goals)
  // determine recommended kit
  if (holdStrength === 'Strong') {
    kitType="oCeS"
  } else {
    kitType="oCeS"
  }

  console.log(holdStrength)

  // Reformat goals string
  console.log(goals)
  if (goals) {
    goals = goals.split(", ").map(goal => {
      return goal.replaceAll(" ", "-").toLowerCase()
    }).join(',')
  }

  
  queryString = (`curl-goals=${goals}&name=${name}&hair-type=${hairType}&result=${holdStrength}&refresh=${refresh}`)
  window.location.href = 'https://onlycurls.com/pages/quiz-results/?' + encodeURIComponent(queryString)
  
}, false);